import axios from "@axios";

let taxesEndpoint = '/taxes'

/**
 * ÍNDICE
 * 
 * {@link getTaxes} - Obtener impuestos
 * {@link addTax} - Agregar impuesto
 * {@link deleteTax} - Eliminar impuesto
 */

/**
 * Obtener todos los impuestos
 * @returns {Promise} response
 */
export const getTaxes = function() {
    try {
        return new Promise((resolve, reject) => {
            axios.get(taxesEndpoint)
                 .then(response => { return resolve(response.data.taxes) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Añadir un impuesto nuevo
 * @returns {Promise} response
 */
export const addTax = function(data) {
    try {
        return new Promise((resolve, reject) => {
            axios.post(taxesEndpoint, data)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}

/**
 * Eliminar un impuesto existente
 * @return {Promise} response
 */
export const deleteTax = function(tax_id) {
    try {
        return new Promise((resolve, reject) => {
            axios.delete(`${taxesEndpoint}/${tax_id}`)
                 .then(response => { return resolve(response.data) })
                 .catch(error => { return reject(error) })
        })
    } catch (error) {
        return error
    }
}